import { productsFromStore } from "./products-from-store";
import { getUserEmail } from './authenticated-user.js';

/**
 * @param basketItems
 * @returns {*}
 */
export function createBasketOpen(basketItems) {
  return productsFromStore(basketItems)
    .then((products) => {
      return {
        'ecommerce': {
          'email': getUserEmail(),
          'cart': {
            'products': products
          }
        },
        "event": "gtm-ee-event",
        "gtm-ee-event-category": "Enhanced Ecommerce",
        "gtm-ee-event-action": "Cart",
        "gtm-ee-event-non-interaction": "False"
      }
    })
}